export const getYears = () => {
  const years = [];

  const today = new Date();
  const yearToday = today.getFullYear();

  if (today.getMonth() === 1) {
    years.push(yearToday - 1);
  }

  years.push(yearToday);

  return years;
};
